import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CustomAutocomplete from '../CustomAutocomplete';
import CleaveNumberFormatting from '../CleaveNumberFormatting';


class Share extends Component {
  static propTypes = {
    share: PropTypes.object.isRequired,
    updateItem: PropTypes.func.isRequired,
    updateTopState: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
  }

  componentWillMount() {
    this.updateItemDebounce = _.debounce(this.updateItemDebounce, 1000);
  }

  delete = (e) => {
    e.preventDefault();
    const { share, updateTopState } = this.props;
    App.Api.delete(share.url).then(
      data => updateTopState(data),
    );
  }

  updateItem = (e) => {
    const { share, updateItem } = this.props;
    updateItem(share.url, e.target.id, e.target.value);
  }

  updateItemCleave = (e) => {
    const { share } = this.props;
    this.updateItemDebounce(e.target.id, e.target.rawValue || 0, share.url);
  }

  updateItemDebounce = (id, rawValue, shareUrl) => {
    const { updateItem } = this.props;
    updateItem(shareUrl, id, rawValue);
  }

  render() {
    const { share, edit } = this.props;
    if (edit) {
      return (
        <div className="flex flex-center mb2 mxn2">
          <div className="col-3 px2">
            <div className="flex flex-center h6 m0 relative text-gray">
              <CustomAutocomplete
                className="input-like border border-alto col-12"
                onChange={this.updateItem}
                value={share.owner_name}
                items={share.investors}
                name="share[owner_name]"
                id="owner_name"
              />
            </div>
          </div>

          <div className="col-3 px2">
            <CleaveNumberFormatting
              value={share.new_amount}
              onChange={this.updateItemCleave}
              className="appearance-textfield border border-alto col-12"
              name="share[new_amount]"
              id="new_amount"
              placeholder="0"
            />
          </div>

          <div className="col-3 px2">
            <p className="center h6 m0 text-gray">{ share.current_amount }</p>
          </div>

          <div className="center col-3 px2">
            <span className="col-3 h6 inline-block m0 text-gray">{ share.percentage }</span>

            <div className="ml2 cursor-pointer inline" onClick={this.delete}>
              <i className="fa fa-trash text-light-gray" />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="flex mxn2">
        <div className="flex flex-center col-3 px2">
          <span
            className="block bg-center bg-cover bg-no-repeat circle header__avatar--investor mr1"
            style={{ backgroundImage: `url(${share.avatar})` }}
          />
          <p className="flex flex-start h6 m0 text-gray truncate">{share.owner_name}</p>
        </div>

        <div className="col-3 px2">
          <p className="center h6 m0 text-gray">{share.new_amount_show}</p>
        </div>

        <div className="col-3 px2">
          <p className="center h6 m0 text-gray">{share.current_amount}</p>
        </div>

        <div className="center col-3 px2">
          <span className="h6 m0 text-gray">{share.percentage}</span>
        </div>
      </div>
    );
  }
}

export default Share;
